import React from "react";
import { Navigate } from "react-router-dom";
import Basic404 from "../pages/AuthenticationInner/Errors/Basic404";

// Landing Index
import OnePage from "../pages/Landing/OnePage";
const authProtectedRoutes = [
];

const publicRoutes = [
  { path: "/auth-404-basic", component: <Basic404 /> },
  {
    path: "/",
    exact: true,
    component: <OnePage />,
  },
  { path: "*", component: <Basic404 /> },
];

export { authProtectedRoutes, publicRoutes };
